import useGoogleMaps from '@/hooks/useGoogleMaps';
import GoogleMap from './GoogleMap';
import createMarkerIcon from './createMarkerIcon';

type LocationMapProps = {
  markers: [
    {
      icon;
      position;
    }
  ];
  type: string;
  apiKey: string;
};

const LocationMap: React.FC<LocationMapProps> = ({
  markers,
  type,
  apiKey
}) => {
  const { googleMaps } = useGoogleMaps(apiKey);

  if (googleMaps) {
    markers.forEach(
      (marker) => (marker.icon = createMarkerIcon(type, googleMaps))
    );
  }

  return (
    <GoogleMap
      api={googleMaps}
      classNames="station-details__location-map"
      markers={markers}
      options={{
        zoom: 17,
        center: markers[0].position,
      }}
    />
  );
};

export default LocationMap;
